import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import classnames from 'classnames';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { Link } from 'dibs-elements/exports/Link';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';
import { startConversationMessage } from '../pdpMessages';
// styles
import styles from './PdpSharedButtons.scss';

export const PdpSharedContactDealerButtonComponent = ({
    fullWidth,
    type,
    launchOrigin,
    item,
    size,
    buttonType,
    source,
    user = {},
    viewer,
}) => {
    const contactTheSellerMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.contactTheSeller"
            defaultMessage="Contact Seller"
        />
    );

    const requestCustomizationMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestCustomization"
            defaultMessage="Request Customization"
        />
    );

    const requestPriceMessage = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestPrice"
            defaultMessage="Request Price"
        />
    );

    const requestMoreImages = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestMoreImages"
            defaultMessage="Request More Images"
        />
    );
    const requestMoreImagesAndVideos = (
        <FormattedMessage
            id="PdpSharedContactDealerButton.requestMore"
            defaultMessage="Request More"
        />
    );

    let modalType = 'CONTACT_DEALER';
    let message;

    switch (type) {
        case 'REQUEST_PRICE':
            message = requestPriceMessage;
            launchOrigin = 'request price button';
            modalType = type;
            break;
        case 'REQUEST_CUSTOMIZATION':
            message = requestCustomizationMessage;
            launchOrigin = 'contact link in pdp - request customization';
            modalType = type;
            break;
        case 'REQUEST_IMAGES':
            message = requestMoreImages;
            modalType = type;
            break;
        case 'REQUEST_IMAGES_AND_VIDEOS':
            message = requestMoreImagesAndVideos;
            modalType = type;
            break;
        default:
            message =
                source === 'shipment-info-link'
                    ? contactTheSellerMessage
                    : startConversationMessage;
            break;
    }

    return (
        <div className={styles.buttonWrapper}>
            <CurrencyProvider
                render={({ currency } = {}) => (
                    <SharedContactDealerWrapper
                        item={item}
                        launchOrigin={launchOrigin}
                        modalType={modalType}
                        user={user}
                        viewer={viewer}
                        currency={currency}
                    >
                        {onClick =>
                            source === 'shipment-info-link' ? (
                                <Link
                                    onClick={onClick}
                                    className={styles.contactSellerLink}
                                    dataTn="item-actions-request-information"
                                >
                                    {message}
                                </Link>
                            ) : (
                                <Button
                                    onClick={onClick}
                                    type={buttonType}
                                    className={classnames({ [styles.fullWidth]: fullWidth })}
                                    dataTn="item-actions-request-information"
                                    size={size}
                                >
                                    {message}
                                </Button>
                            )
                        }
                    </SharedContactDealerWrapper>
                )}
            />
        </div>
    );
};

PdpSharedContactDealerButtonComponent.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    viewer: PropTypes.object,
    source: PropTypes.string,
    type: PropTypes.oneOf([
        'CONTACT_DEALER',
        'REQUEST_CUSTOMIZATION',
        'REQUEST_PRICE',
        'REQUEST_IMAGES',
        'REQUEST_IMAGES_AND_VIDEOS',
    ]),
    fullWidth: PropTypes.bool,
    launchOrigin: PropTypes.string,
    buttonType: PropTypes.oneOf(['primary', 'secondary', 'textCta']),
};

PdpSharedContactDealerButtonComponent.defaultProps = {
    size: 'large',
    buttonType: 'primary',
    type: 'CONTACT_DEALER',
    launchOrigin: 'contact link in pdp - sidebar',
    fullWidth: true,
};

export const PdpSharedContactDealerButton = createFragmentContainer(
    PdpSharedContactDealerButtonComponent,
    {
        item: graphql`
            fragment PdpSharedContactDealerButton_item on Item {
                ...SharedContactDealerWrapper_item
            }
        `,
        user: graphql`
            fragment PdpSharedContactDealerButton_user on User {
                ...SharedContactDealerWrapper_user
            }
        `,
        viewer: graphql`
            fragment PdpSharedContactDealerButton_viewer on Viewer {
                ...SharedContactDealerWrapper_viewer
            }
        `,
    }
);
